import { createClient } from '@supabase/supabase-js';

const PROD_SUPABASE_URL = 'https://uvvljtysxrpsxpuiipeg.supabase.co';
const PROD_SUPABASE_ANON_KEY = 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6InV2dmxqdHlzeHJwc3hwdWlpcGVnIiwicm9sZSI6ImFub24iLCJpYXQiOjE3ODIxMzc1NzAsImV4cCI6MjA5NzcxMzU3MH0.qPtS8fMQM4cKFxkgBZMDiFhHQfxb9K9qORQoX9MILRk';
const PROD_N8N_BASE_URL = 'https://judy8108.app.n8n.cloud';

const url = (import.meta.env.VITE_SUPABASE_URL as string | undefined) || PROD_SUPABASE_URL;
const anonKey = (import.meta.env.VITE_SUPABASE_ANON_KEY as string | undefined) || PROD_SUPABASE_ANON_KEY;

export const isSupabaseConfigured = Boolean(url && anonKey);

export const supabase = createClient(url, anonKey);

export const N8N_BASE_URL = (import.meta.env.VITE_N8N_BASE_URL as string | undefined) || PROD_N8N_BASE_URL;
